import React from 'react';
import { bool, func, string } from 'prop-types';
import './CardHeader.scss';

class CardHeader extends React.Component {
  static propTypes = {
    icon: string,
    isAdded: bool,
    onRemove: func,
    title: string,
    isApplied: bool
  };

  render() {
    const { icon, isAdded, onRemove, title, isApplied } = this.props;

    return (
      <div className="card__header">
        <div className="card__row">
          <div className="differential-title__container">
            <i className={icon} />
            <div className="differential__title">{title}</div>
          </div>
          {isAdded && isApplied && (
            <div className="differential__remove pointer" onClick={onRemove}>
              <i className="icon-trash" />
              Remove
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CardHeader;
